<div>
    <div *ngFor="let option of options">
        <label class="checkbox">
            <input type="checkbox" [(ngModel)]="checkboxMap[option]"  (change)="update()">
            {{option}}
        </label>
    </div>
</div>